import script from "./AllStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllStudentsSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./AllStudentsSubpage.vue?vue&type=style&index=0&id=0e220fdd&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e220fdd"]])

export default __exports__